import React from "react";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";

import useSegmentActions from "../hooks/useSegmentActions";
import Modal from "../Modal";
import useFirebaseSegment from "../hooks/useFirebaseSegment";

const SegmentDeletePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const segment = useFirebaseSegment(id!);

  const { deleteSegment } = useSegmentActions();

  const actions = () => (
    <React.Fragment>
      <Button
        variant="destructive"
        onClick={() => {
          deleteSegment(id!);
        }}
      >
        Delete
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!segment) {
      return <div>Loading...</div>;
    }

    return (
      <React.Fragment>
        <div>Name:{segment.name}</div>
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Delete Segment"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default SegmentDeletePage;
